import React, { FC, memo } from 'react';

interface Props {
  user?: { id: number; firstname?: string; lastname?: string };
}

const EmployeeCell: FC<Props> = ({ user }) => {
  return <div>{user ? `${user.firstname} ${user.lastname}` : ''}</div>;
};

export default memo(EmployeeCell, (prevProps, nextProps) => prevProps.user?.id === nextProps.user?.id);
